import { render } from "./support-tickets-grid.vue?vue&type=template&id=078c33f1&scoped=true"
import script from "./support-tickets-grid.vue?vue&type=script&lang=js"
export * from "./support-tickets-grid.vue?vue&type=script&lang=js"

import "./support-tickets-grid.vue?vue&type=style&index=0&id=078c33f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078c33f1"]])

export default __exports__